import apiClient from './api/client';
import { Order, PaginatedResponse } from '../types';

export const orderService = {
    getOrders: async (params?: any): Promise<PaginatedResponse<Order>> => {
        const response = await apiClient.get('/orders', { params });
        return response.data;
    },

    getOrder: async (id: string): Promise<Order> => {
        const response = await apiClient.get(`/orders/${id}`);
        return response.data;
    }
};
